import type { FC } from 'react';
import type {
  EChartsOption,
  TooltipComponentFormatterCallback,
  TooltipComponentFormatterCallbackParams,
} from 'echarts';
// import type { RootState } from '@/store/store';
import { ChartsTypeEnum, type ITreeMapConfigItem } from '../../../types';

import { init } from 'echarts';
import { useEffect, useRef, useMemo, useContext } from 'react';
import { DashboardSearchContext } from '@/pages/dashboard-search';
import type { ITreeMapSeriesFormatterParams } from './types';

// import { themeColors } from '@/flowbite-theme';
// import { useSelector } from 'react-redux';
// import { themeColors } from '@/flowbite-theme';

type ITreeMapChartProps = {
  data: ITreeMapConfigItem[];
  labels: { x: string; y: string };
  height: number;
  showChart: boolean;
};

const TreeMap: FC<ITreeMapChartProps> = ({
  data,
  height,
  showChart,
  labels,
}) => {
  // const { currentTheme } = useSelector((state: RootState) => state.theme);
  const sharesRef = useRef<HTMLDivElement | null>(null);
  const { colorMap, onlyMyBrandsMap } = useContext(DashboardSearchContext);

  const options: EChartsOption = useMemo(() => {
    const formatter: TooltipComponentFormatterCallback<
      TooltipComponentFormatterCallbackParams & ITreeMapSeriesFormatterParams
    > = (params) => {
      return `
        ${params.data.name}
        </br>
        ${labels?.x}: ${params?.data?.value}
        `;
    };

    return {
      tooltip: {
        formatter: formatter as unknown,
      },
      series: {
        // nodeClick: false,
        roam: false,
        name: labels?.x,
        label: {
          show: true,
          formatter: '{b}, {c}',
        },
        type: ChartsTypeEnum.treeMap,
        // colorMappingBy: 'value',
        // colorAlpha: [0, 1],
        data: data.map(({ name, sizeValue }) => ({
          name: name,
          label: name,
          value: sizeValue,
          itemStyle: {
            color: onlyMyBrandsMap?.[name] ?? colorMap.get(name),
          },
        })),
        levels: [
          {
            // color: ['#942e38', '#aaa', '#269f3c'],
            // colorMappingBy: 'value',
            // itemStyle: {
            //   borderWidth: 3,
            //   borderColor: '#333',
            //   gapWidth: 3,
            // },
          },
        ],
      },
    } as EChartsOption;
  }, [data, colorMap]);

  useEffect(() => {
    const myChart = init(sharesRef.current);

    showChart && myChart.setOption(options);

    return () => myChart.dispose();
  }, [options, height, showChart]);

  return (
    <div
      className={`${height === 500 ? 'h-[500px]' : 'h-[300px]'} w-full`}
      ref={sharesRef}
    />
  );
};

export default TreeMap;
